import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface LoaderProps {
  onFinish: () => void;
}
const LOGO_URL = 'https://i.imgur.com/1npk9MS.png';
export function Loader({
  onFinish
}: LoaderProps) {
  useEffect(() => {
    const timer = setTimeout(onFinish, 2800);
    return () => clearTimeout(timer);
  }, [onFinish]);
  return <motion.div initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.9,
    ease: [0.25, 0.46, 0.45, 0.94]
  }} className="fixed inset-0 bg-night z-[9999] flex flex-col items-center justify-center" data-id="element-275" data-mp="2vmcg4eyztwsx">
      <div className="relative w-[140px] h-[140px] flex items-center justify-center mb-7" data-id="element-276" data-mp="39mdhdvj6768x">
        <div className="absolute inset-0 rounded-full animate-loader-ring" style={{
        background: 'radial-gradient(circle, rgba(61,107,61,.3) 0%, transparent 70%)'
      }} data-id="element-277" data-mp="3ekose9l7bmsq" />
        <img src={LOGO_URL} alt="Refugio Caracolí" className="relative w-[110px] h-[110px] object-contain animate-loader-glow" data-id="element-278" data-mp="avlej07ww02o" />
      </div>
      <motion.div initial={{
      opacity: 0,
      y: -18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3
    }} className="font-display text-base font-light tracking-[0.5em] text-gold uppercase" data-id="element-279" data-mp="2ajl8k749vy00">
        Refugio Caracolí
      </motion.div>
      <div className="w-40 h-px bg-white/[0.07] mt-7 rounded-full overflow-hidden" data-id="element-280" data-mp="2fio5f4a3mxww">
        <motion.div initial={{
        width: '0%'
      }} animate={{
        width: '100%'
      }} transition={{
        duration: 2.8,
        ease: 'easeInOut'
      }} className="h-full bg-gradient-to-r from-forest-500 to-gold" data-id="element-281" data-mp="2u83xqopa3bep" />
      </div>
    </motion.div>;
}